import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import Bar from '../Bar';
import { ValueMappers, FormatValue } from '../../types';

interface Props {
  data: any[];
  scales: ValueMappers;
  values: ValueMappers;
  formatValue: FormatValue;
}

class Bars extends React.Component<Props & RouteComponentProps> {
  render() {
    const { data, scales, values, formatValue, location } = this.props;

    return (
      <g>
        {data.map((d, i) => (
          <Bar
            key={i} // number and order of bars is fixed (didn't ?)
            scales={scales}
            x={+values.x(d, i)}
            y={values.y(d, i)}
            label={formatValue(d, i)}
            pathname={location.pathname}
          />
        ))}
      </g>
    );
  }
}

export default withRouter(Bars);
